import React from 'react';
import InvestorMailboxSC from './investor-mailbox.styled';
import InfoBanner from '../../../components/info-banner';
import ContentWrap from '../../../components/content-wrap';
import InvestorMailboxBanner from '../../../components/investor-mailbox-banner';
import InvestorMailboxContent from '../../../components/investor-mailbox-content';

const InvestorMailbox = () => {
  return (
    <InvestorMailboxSC>
      <InfoBanner>
        <InvestorMailboxBanner />
      </InfoBanner>
      <ContentWrap>
        <InvestorMailboxContent />
      </ContentWrap>
    </InvestorMailboxSC>
  );
};

export default InvestorMailbox;
